import { call, put, takeLatest } from "redux-saga/effects";
import {
  deleteSavingsSource,
  addSavingsSource,
  updateSavingsSource,
} from "../slices/savingsSourcesSlice";
import { setData } from "../slices/capitalOverviewSlice";
import { api } from "../utils/api";

function* refreshCapitalSaga() {
  try {
    const {
      savings_sources,
      formattedBalance,
      difference,
      numberOfSources,
      widget,
    } = yield call(api.getCapitalOverview);

    const savingsSourcesData = {
      cash: savings_sources.cash,
      bank_account: savings_sources.bank_account,
      stocks: savings_sources.stocks,
      crypto: savings_sources.crypto,
    };

    yield put(
      setData({
        widget,
        formattedBalance,
        difference,
        numberOfSources,
        savingsSourcesData,
      })
    );
    console.log("Capital refreshed:", savingsSourcesData);
  } catch (error) {
    console.error("Failed to refresh capital", error);
  }
}

export default function* capitalSaga() {
  yield takeLatest(
    [deleteSavingsSource.type, addSavingsSource.type, updateSavingsSource.type],
    refreshCapitalSaga
  );
}
